import { SectionVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';
import { ModelEventoDTO } from 'shell/models/act-category-list';

export const transformerGeneralData341 = (values?: ModelEventoDTO): SectionVM | undefined => {
  if (!values) {
    return;
  }

  const isForeign =
    Boolean(values.datiEventoMatrimonio?.luogoCelebrazione?.idStato) &&
    values.datiEventoMatrimonio?.luogoCelebrazione?.idStato !== CODE_STATE_ITALIAN;

  return {
    dateMarriage: values.datiEventoMatrimonio?.dataEvento
      ? DateTime.fromISO(values.datiEventoMatrimonio?.dataEvento)
      : null,
    isForeign,
    foreign: isForeign
      ? {
          state: {
            id: values.datiEventoMatrimonio?.luogoCelebrazione?.idStato || '',
            value: values.datiEventoMatrimonio?.luogoCelebrazione?.nomeStato || '',
          },
        }
      : undefined,
    italian:
      !isForeign && values.datiEventoMatrimonio?.luogoCelebrazione?.idComune
        ? {
            municipality: {
              description: values.datiEventoMatrimonio?.luogoCelebrazione?.nomeComune || '',
              province: values.datiEventoMatrimonio?.luogoCelebrazione?.siglaProvincia || '',
              code: Number.parseInt(
                values.datiEventoMatrimonio?.luogoCelebrazione?.idComune || '',
                10
              ),
              id: values.datiEventoMatrimonio?.luogoCelebrazione?.idComune || '',
              idProvince: Number.parseInt(
                values.datiEventoMatrimonio?.luogoCelebrazione?.idProvincia || '',
                10
              ),
            },
          }
        : undefined,
    celebratedBy:
      values.datiEventoMatrimonio?.officianteEvento?.cognome ||
      values.datiEventoMatrimonio?.officianteEvento?.nome
        ? `${values.datiEventoMatrimonio?.officianteEvento.cognome || ''} ${
            values.datiEventoMatrimonio?.officianteEvento.nome || ''
          }`
        : undefined,
  };
};
